module.exports = __webpack_public_path__ + "img/ic-file.4c92da5c.svg";